import { FieldControllerTypes } from '../../../components/form_v2/types';
import TitlePage from '../../../components/layout/Page/TitlePage';
import { eliminateOjectNotTruthyValues, isSubmitEnabled } from '../../../lib/helperFuncs';
import HttpService from '../../../services/HttpService';
import RegistrationStepComponent from './RegistrationStepComponent';
import { countryOptions, initialValuesEditErgo, initialValuesProject } from './types';
import { editProjectValidation, newProjectValidation } from './validationSchema';
import { House } from '@mui/icons-material';
import { useSnackbar } from 'notistack';
import AsyncBackdropSubmit from '../../../components/AsyncBackdropSubmit';
import React from 'react';
import ContinueProcess from './ContinueProcess';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Button, Divider, Box } from '@mui/material';
import { Form, Formik } from 'formik';
import FormStepperBuilder from '../../../components/form_v2/highLevelComponents/FormStepperBuilder';
import FormSkeleton from '../../../components/Skeletons/FormSkeleton';
import DialogAction from '../../../components/Dialog/DialogAction';
import FormActionButtonLayout from '../../../components/layout/Form/FormActionButtonLayout';
import PreviewErgo from '../Ergo/PreviewErgo';
import { insertErgoFields } from '../Ergo/static';
import { fetchContributorsTypesOptions, fetchErgoTypesOptions, fetchOAtypeFormat, getErgo } from '../../../lib/fetchers';
import AddIcon from '@mui/icons-material/Add';
import DialogAddContributor from '../../../components/Dialog/DialogAddContributor';

const RegistrationProject = () => {
  document.title = 'Εκκίνηση Ο/Α Έργου';

  const [openBackdrop, setOpenBackdrop] = React.useState<boolean>(false);
  const { enqueueSnackbar } = useSnackbar();
  const [response, setResponse] = React.useState<any>({});
  const [typeOptions, setTypeOptions] = React.useState<any[]>([]);
  const [locations, setLocations] = React.useState<any[]>([]);
  const [contributors, setContributors] = React.useState<any[]>([]);
  // const [connectors, setConnectors] = React.useState<any[]>([]);
  const [renderPreview, setRenderPreview] = React.useState(false);
  const [openCancel, setOpenCancel] = React.useState(false);
  const [isLoadingProject, setIsLoadingProject] = React.useState(false);
  const [open, setOpen] = React.useState<boolean>(false);
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const [contributorsOptions, setContributorsOptions] = React.useState<any[]>([]);
  const [formatOptions, setFormatOptions] = React.useState<any[]>([]);
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();

  const handleClickOpen = () => {
    setOpen(true);
  };

  const step1Form = [
    [{
      control: FieldControllerTypes.select,
      type: 'select',
      label: 'Επιλέξτε Χώρα Δημιουργίας Έργου',
      name: 'countryId',
      required: true,
      options: countryOptions
    },
    {
      control: FieldControllerTypes.input,
      type: 'input',
      label: 'Τίτλος Ο/Α Έργου',
      name: 'projectTitle',
      required: true,
    }]
  ];

  const step1 = {
    label: 'Στοιχεία Εκκίνησης Καταχώρισης Ο/Α Έργου',
    content: step1Form,
    icon: <House/>
  };

  const Step = [
    {...step1}
  ];

  const getTypeOptions = async () => {
    try {
      const response = await fetchErgoTypesOptions(); 
      const _ergoTypeOptions = response?.['o:terms']
        .map((x:any) => {
          return {
            key: x, 
            value: x
          };
        })
        .sort((a: any,b: any) => a.key.localeCompare(b.key, 'el'));  
      setTypeOptions(_ergoTypeOptions);
    } catch (error) {
      console.error(error);
    }
  };

  const getLocations = async () => {
    try {
      const response = await HttpService.getAxiosClient().get(`${process.env.REACT_APP_BACKEND_URL}/locations/parametrics`);    
      const _locationsOptions = response.data
        .map((x:any) => {
          return {
            key: x.key, 
            value: x.value
          };
        })
        .sort((a: any,b: any) => a.key.localeCompare(b.key, 'el'));        
      setLocations(_locationsOptions);
    } catch (error) {
      console.error(error);
    }
  };
  
  // const getConnectors = async () => {
  //   try {
  //     const response = await HttpService.getAxiosClient().get(`${process.env.REACT_APP_BACKEND_URL}/suntelestes/parametrics`);         
  //     const _connectorsOptions = response?.data.map((x:any) => {
  //       return {
  //         key: x.key, 
  //         value: x.value
  //       };
  //     })
  //       .sort((a: any,b: any) => a.key.localeCompare(b.key, 'el'));                
  //     setConnectors(_connectorsOptions);
  //   } catch (error) {
  //     console.error(error);
  //   }
  // };

  const getContributorsOptions = async () => {
    try {
      const response = await fetchContributorsTypesOptions();
      const _contributorsTypeOptions = response?.['o:terms']
        .map((x:any) => {
          return {
            key: x, 
            value: x
          };
        })
        .sort((a: any,b: any) => a.key.localeCompare(b.key, 'el'));        
      setContributorsOptions(_contributorsTypeOptions);
    } catch (error) {
      console.error(error);
    }
  };

  const getContributors = async () => {
    try {
      const response = await HttpService.getAxiosClient().get(`${process.env.REACT_APP_BACKEND_URL}/suntelestes/parametrics`);         
      const _contributorsOptions = response?.data.map((x:any) => {
        return {
          key: x.key, 
          value: x.value
        };
      })
        .sort((a: any,b: any) => a.key.localeCompare(b.key, 'el'));                
      setContributors(_contributorsOptions);
    } catch (error) {
      console.error(error);
    }
  };

  const getTypeFormat = async () => {
    try {
      const response = await fetchOAtypeFormat();
      const _projectFormatOptions = response?.['o:terms']
        .map((x:any) => {
          return {
            key: x, 
            value: x
          };
        })
        .sort((a: any,b: any) => a.key.localeCompare(b.key, 'el'));      
      setFormatOptions(_projectFormatOptions);
    } catch (error) {
      console.error(error);
    }
  };

  const onSubmit = async (values: any) => {
    try {
      setOpenBackdrop(true);
      const response = await HttpService.getAxiosClient().post(`${process.env.REACT_APP_BACKEND_URL}/ergo`, 
        eliminateOjectNotTruthyValues({...values })
      );            
      setResponse({
        ...response.data,
        id: response.data.id,
        projectTitle: response.data.projectTitle,
        projectUniqueCode: response.data.uniqueCode,
        projectIdentifier: response.data.uniqueIdentifier
      });
      localStorage.setItem('ergoId', response.data.id.toString());
      enqueueSnackbar('Η εκκίνηση καταχώρισης Ο/Α Έργου πραγματοποιήθηκε επιτυχώς', { variant: 'success' });
    } catch (error) {
      console.error(error);
      enqueueSnackbar('Η εκκίνηση καταχώρισης Ο/Α Έργου απέτυχε, παρακαλώ προσπαθήστε ξανά.', { variant: 'error' });
    }
    setOpenBackdrop(false);
  };

  const onSubmitEdit = async (values: any) => {
    setOpenBackdrop(true);        
    try {
      await HttpService.getAxiosClient().put(`${process.env.REACT_APP_BACKEND_URL}/ergo/${response.id}`, 
        eliminateOjectNotTruthyValues({...values })
      );
      enqueueSnackbar('H καταχώριση Ο/Α Έργου υποβλήθηκε επιτυχώς', { variant: 'success' });
      navigate('/admin/project/dashboard');
      localStorage.removeItem('ergoId');
    } catch (error) {
      console.error(error);
      enqueueSnackbar('H καταχώριση Ο/Α Έργου απέτυχε, παρακαλώ προσπαθήστε ξανά.', { variant: 'error' });
    } 
    setOpenBackdrop(false);
  };

  const onSubmitContributorForm = async (values: any) => {
    setIsLoading(true);
    try {
      
      const resp = await HttpService.getAxiosClient().post(`${process.env.REACT_APP_BACKEND_URL}/suntelestes`, values);
      setContributors([
        ...contributors, 
        ...[{ key: `${resp.data.title} - ${resp.data.role}`, value: resp.data.id }]
      ]);
      
      enqueueSnackbar('Επιτυχής δημιουργία Eμπλεκόμενου', { variant: 'success' });
    } catch (error) {
      console.error(error);
      enqueueSnackbar('Παρουσιάστηκε σφάλμα, παρακαλούμε προσπαθήστε αργότερα.', { variant: 'error' });
    }
    setIsLoading(false);
    setOpen(false);
  };

  const onCancelErgo = async () => {
    try {
      setOpenBackdrop(true);
      await HttpService.getAxiosClient().delete(`${process.env.REACT_APP_BACKEND_URL}/ergo/${response?.id}`);
      setResponse({});
      enqueueSnackbar('Η διαγραφή Ο/Α Έργου πραγματοποιήθηκε επιτυχώς', { variant: 'success' });
    } catch (error) {
      console.error(error);
      enqueueSnackbar('Η διαγραφή Ο/Α Έργου απέτυχε, παρακαλώ προσπαθήστε ξανά.', { variant: 'error' });
    } 
    setOpenBackdrop(false);
  };

  const details = [
    [{
      name: 'Αναγνωριστικό Έργου',
      value: response?.projectIdentifier
 
    },
    {
      name: 'Μοναδικός Κωδικός',
      value: response?.projectUniqueCode
    }]
  ];

  const fetchErgo = async (ergo_id: string) => {
    try {
      setIsLoadingProject(true);      
      const {project: ergo_object} = await getErgo(ergo_id);                  
      setResponse(ergo_object); 
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoadingProject(false);
    }
  };

  React.useEffect(() => {
    const ergoId = localStorage.getItem('ergoId');
    searchParams.delete('edit');
    searchParams.delete('preview');
    setSearchParams(searchParams);

    ergoId 
      ? fetchErgo(ergoId)
      : setResponse({});
      
    Promise.all([
      getLocations(),
      // getConnectors(),
      getTypeOptions(),
      getContributorsOptions(),
      getContributors(),
      getTypeFormat()
    ]);
  }, []);

  React.useEffect(() => {
    const unloadCallback = (event: any) => {
      event.preventDefault();
      event.returnValue = '';
      return '';
    };
  
    window.addEventListener('beforeunload', unloadCallback);
    return () => window.removeEventListener('beforeunload', unloadCallback);
  }, []);

  return (
    <>
      <AsyncBackdropSubmit isLoading={openBackdrop}>
        Παρακαλώ περιμένετε μέχρι να ολοκληρωθεί η διαδικασία...
      </AsyncBackdropSubmit>
      <TitlePage  
        backButton={false}
        title={Object.prototype.hasOwnProperty.call(Object.fromEntries([...searchParams]), 'preview')
          ? 'Προεπισκόπηση Καταχώρισης Ο/Α Έργου'
          : 'Εκκίνηση Καταχώρισης Ο/Α Έργου'}/>
      {isLoadingProject
        ? <FormSkeleton lines={6}/>
        : Object.keys(response).length === 0 ? 
          <RegistrationStepComponent 
            initialValues={initialValuesProject} 
            validation={newProjectValidation} 
            step={Step}
            onSubmit={onSubmit} />
          : !renderPreview
            ? <>
              <ContinueProcess
                renderOutsideReactRouter={true}
                label={'Συνέχεια επεξεργασίας στο OMEKA'}
                details={details}
                link={`https://repository.ekkomed.gr/omeka-s/admin/item/${response.id}/edit`}/>
              <Divider sx={{width: '50%', display: 'flex', mx: 'auto'}}> Ή Επεξεργαστείτε Εδώ </Divider>
              <Box mt={3} justifyContent='end'
                display='flex'> 
                <Button
                  variant='contained'
                  color='primary'
                  startIcon={<AddIcon />}
                  onClick={handleClickOpen}>
                  Προσθήκη Νέου Εμπλεκόμενου
                </Button>
                <DialogAddContributor title={'Καταχώριση Εμπλεκόμενου Έργου'} 
                  open={open}
                  isLoading={isLoading}
                  contributors={contributors}
                  options={contributorsOptions}
                  handleClose={()=> setOpen(false)}
                  onAccept={onSubmitContributorForm}
                />
              </Box>
              <Formik
                enableReinitialize
                onSubmit={()=> undefined}
                initialValues={initialValuesEditErgo(response)}
                validationSchema={editProjectValidation}
                validateOnBlur={false}
              >
                {formik =>
                  (<>
                    <Form>
                      <FormStepperBuilder formik={formik} 
                        form={insertErgoFields(typeOptions, locations, contributors,
                          formatOptions)}/>
                      <FormActionButtonLayout>
                        <Button 
                          variant='outlined' 
                          color='error'
                          onClick={() => setOpenCancel(true)}
                        > 
                          Ακύρωση Καταχώρισης               
                        </Button>
                        <Button 
                          variant='contained' 
                          disabled={
                            isSubmitEnabled(
                              formik?.errors,
                              Object.prototype.hasOwnProperty.call(Object.fromEntries([...searchParams]), 'edit') 
                                ? true
                                : formik?.dirty
                            )
                          }
                          onClick={() => {
                            setResponse({...formik.values} as any);
                            searchParams.set('preview', 'true');
                            searchParams.delete('edit');
                            setSearchParams(searchParams);
                            setRenderPreview(true);
                          }}
                        > 
                          Προεπισκόπηση Καταχώρισης
                        </Button>
                      </FormActionButtonLayout>
                    </Form>
                  </>)
                }
              </Formik>
              <DialogAction
                title='Ακύρωση Καταχώρισης Ο/Α Έργου'
                content={'Είστε σίγουρος ότι θέλετε να ακυρώσετε την καταχώριση;'}
                open={openCancel} 
                onAccept={onCancelErgo}
                handleClose={() => setOpenCancel(false)}/>
            </> 
            : 
            <PreviewErgo 
              onSubmit={onSubmitEdit}
              data={response} 
              setRenderPreview={setRenderPreview}
              isLoading={isLoadingProject}
            />
      } 
    </>
  );
};

export default RegistrationProject;